import { render, staticRenderFns } from "./Conferences.vue?vue&type=template&id=3d775849&scoped=true"
import script from "./Conferences.vue?vue&type=script&lang=js"
export * from "./Conferences.vue?vue&type=script&lang=js"
import style0 from "./Conferences.vue?vue&type=style&index=0&id=3d775849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d775849",
  null
  
)

export default component.exports